/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { addLatestQuestion, fetchChats, fetchLastChat, selectChats } from '../../redux/personaliseLessons/askCreatorSlice'
import { useState } from 'react'
import AudioPlayer from './AudioPlayer'
import { PulseLoader } from 'react-spinners'
import { selectCourseList } from '../../redux/personaliseLessons/courseListSlice'
import { selectAuthentication } from '../../redux/personaliseLessons/authenticationSlice'
import { Mixpanel } from '../../config/Mixpanel'
import constants from './utilities/constants'
import useWindowSize from '../../hooks/useWindowSize'

const predefinedQuestionList = [
    "Give me a few examples to understand this better.",
    "Simplify the video as if explaining to a 10 year old.",
    "Give a few top tips & tricks to implement this in my work."
]


const ChatSection = ({ course_slug, video_id, lesson_id, isToggled }) => {

    const [ userQuery, setUserQuery ] = useState("")
    const dispatch = useDispatch()
    const uid = useSelector(selectAuthentication)?.uid
    const subject_name = useSelector(selectCourseList)?.courseName
    const { loading, chat_history, error, loadingMessage } = useSelector(selectChats)
    const scrollRef = useRef(null)
    const { width } = useWindowSize()
       
    useEffect(() => {
        if (lesson_id){
            dispatch(fetchChats({ user_id: uid, lesson_id: lesson_id, course_name: subject_name }))
        }
    }, [lesson_id])

    const handleClick = (item) => {
        Mixpanel.track(constants.Mixpanel.LESSON_PAGE_PRE_DEFINED_DOUBT_WAS_CLICKED)
        const fetchData = async () => {
            try {
                await dispatch(addLatestQuestion({role:"user", content: item}))
                await dispatch(fetchLastChat({ user_id: uid, video_id: video_id, lesson_id: lesson_id, query: item, course_name: subject_name, is_voice: isToggled }))
            }catch (err) {
                console.log(err.message);
            }
        }
        fetchData()
    }

    useEffect(() => {
        const parentElement = scrollRef?.current;
        const lastChild = parentElement?.lastChild;

        if (lastChild && width >= 1024) {
            lastChild.scrollIntoView({ behavior: 'smooth' });
        }
    }, [scrollRef, chat_history?.length])

    const handleUserDoubt = (e) => {
        e.preventDefault()
        Mixpanel.track(constants.Mixpanel.LESSON_PAGE_DOUBT_WAS_ASKED)
        dispatch(addLatestQuestion({role:"user", content: userQuery}))
        dispatch(fetchLastChat({ user_id: uid, video_id: video_id, lesson_id: lesson_id, query: userQuery, course_name: subject_name, is_voice: isToggled }))
        setUserQuery("")
    }
    
     
    return (
        <div className='bg-[#2D4F71] p-3 lg:p-6 rounded-xl reactour-chatsection'>
            {
                chat_history?.length <= 0 ? predefinedQuestionList?.map((item, index) => (
                    <p key={index} className='border text-center text-sm rounded-xl py-2 px-1 border-[#6890B7] mb-2 text-[#92BBE3] cursor-pointer' onClick={() => handleClick(item)}>
                        {item}
                    </p>
            )) : 
                <div ref={scrollRef} className='flex flex-col justify-start h-[400px] lg:h-[228px] overflow-y-scroll takeaway'>
                    {chat_history?.map((item, index)=> (
                        <div key={index}  className={`max-w-[80%] leading-[17px] mt-3 p-2 text-sm ${item?.role === 'user' ? 'self-end border-2 border-[#6890B7] rounded-xl mr-2' : item?.role === 'system' && item?.content?.includes("https://personlaize-data-bucket.s3.amazonaws.com") ? "" : 'self-start bg-[#639DD4] rounded-xl'}`}>
                            {item?.content?.includes("https://personlaize-data-bucket.s3.amazonaws.com") ? 
                            <AudioPlayer url={item?.content}/> : item?.content?.split('\n')?.map((point) => (
                                <p className={`${item?.role === 'system' ? 'mb-2' : ''}`}>{point}</p>
                            ))}
                        </div> 
                    ))}
                    {loadingMessage ? <p>Loading...</p> : null}
                    {loading ? <div className='bg-[#639DD4] mt-2 w-fit flex items-center rounded-lg p-2'> Audio<PulseLoader size={3} color='#2D4F71' className='mt-2'/></div> : null}
                    {error ? <p>Something went wrong try again later</p> : null}
                </div>
            }
            {predefinedQuestionList.length !== 0 && chat_history?.length <= 0 ? <p className='text-center my-4'>or</p> : null}
            <form onSubmit={handleUserDoubt}>
                <div className='relative mt-3'>
                    <input 
                        type="text"
                        placeholder='Ask your question'
                        disabled={loading}
                        value={userQuery}
                        onChange={(e) => setUserQuery(e.target.value)}
                        className='w-full rounded-xl py-2.5 bg-[#17395A] placeholder:text-white/50 placeholder:text-sm outline-none border-none answer_text pr-14'
                    />
                    <button type='submit' disabled={!userQuery || loading} className='absolute disabled:opacity-50 transform top-1/2 -translate-y-1/2 right-3 bg-[#17395A] text-[#3791EC] text-sm' onClick={handleUserDoubt}>Send</button>
                </div>
            </form>
        </div>
    )
}

export default ChatSection